export default {
  // 新增装修巡检信息
  addRenovation: 'backend.odc.decorationinspection.add',
  // 删除装修巡检信息
  deleteRenovation: 'backend.odc.decorationinspection.delete',
  // 编辑装修巡检信息
  editRenovation: 'backend.odc.decorationinspection.edit',
  // 查看装修巡检信息
  lookRenovation: 'backend.odc.decorationinspection.get',
  // 分页寻找巡检信息
  listRenovation: 'backend.odc.decorationinspection.page.list',

  // 新增日常巡检信息
  addDaily: 'backend.odc.daytodayinspection.add',
  // 删除
  deleteDaily: 'backend.odc.daytodayinspection.delete',
  // 编辑
  editDaily: 'backend.odc.daytodayinspection.edit',
  // 查看详情
  lookDaily: 'backend.odc.daytodayinspection.get',
  // 分页获取日常巡检
  listDaily: 'backend.odc.daytodayinspection.page.list',
  // 根据楼层id获取商场楼层详细信息
  option: 'backend.org.brms.mallinfo.list.for.option',
  // 获取商店信息
  getShopInfo: 'backend.org.brms.inside.mallShopInfo.page.list',
  // 根据Id 获取指定用户名
  getIndexUser: 'backend.org.ums.user.get',
  // 获取对应权限的按钮
  getButton: 'backend.org.ums.permission.currentuser.listButtons',
  // 获取申诉详情
  getAppealDetail: 'backend.odc.inspectionappeal.add',
  // 审核接口
  auditing: 'backend.odc.inspectionappeal.edit',
  // 确认巡检
  confirmInspection: 'backend.odc.inspectionappeal.agree'
}
